module.exports = __webpack_public_path__ + "static/media/printerRoll.aa5e491f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/printerRoll.png
// module id = 1641
// module chunks = 0